import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { parseJwt } from '~/utils/jwt';

export type Payload = {
  username?: string;
  avatarId?: string | null;
  isChallengeable?: boolean | null;
  roles?: string;
  sub: number; // User id
  exp: number; // Date of expiration
  iat: number; // Date of creation
  access_token: string;
  refresh_token: string;
  uuid: string;
};

type AuthState = {
  imLoggedAndValid: () => boolean;
  payload: Payload | null;
  setPayload: (payload: Payload) => void;
  unSetPayload: () => void;
  logout: () => void;
};

export const useAuth = create<AuthState>()(
  persist(
    (set, get) => ({
      imLoggedAndValid: () => {
        if (typeof window === 'undefined') return false;
        const payload = parseJwt(get().payload?.access_token ?? 'vide');
        const payloadStorage = get().payload;
        if (payload && payloadStorage) {
          const newData: Payload = {
            access_token: payloadStorage.access_token,
            refresh_token: payloadStorage.refresh_token,
            username: payload.username,
            exp: payloadStorage.exp,
            iat: payloadStorage.iat,
            sub: payloadStorage.sub,
            roles: payload.roles,
            avatarId: payload.avatarId,
            isChallengeable: payload.isChallengeable,
            uuid: payload.uuid,
          };
          if (!newData.refresh_token && newData.exp * 1000 < Date.now()) {
            get().unSetPayload();
            return false;
          }
          set({
            payload: newData,
          });
          return true;
        }

        get().unSetPayload();
        return false;
      },
      payload: null,
      setPayload: (payload: Payload) => {
        set({
          payload,
        });
      },
      unSetPayload: () => {
        set({
          payload: null,
        });
      },
      logout: () => {
        get().unSetPayload();
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
